import type { SavedBlob } from "api/generated/model";
import { formatBlobUrl } from "components/fileUploader/utils";

import * as theme from "./BlobLinkList.css";

interface BlobLinkListProps {
    blobs: SavedBlob[];
    blobIds: string[] | undefined;
}
export function BlobLinkList({ blobs, blobIds }: BlobLinkListProps) {
    return (
        <div className={theme.root}>
            {blobIds?.map((fileId) => {
                // Blobs missing in blobs are not rendered - they are deleted blobs
                const blob = blobs.find((blob) => blob.id === fileId);
                return blob ? (
                    <a
                        key={blob.id}
                        href={formatBlobUrl(blob.id)}
                        target="_blank"
                    >
                        {blob.fileName}
                    </a>
                ) : null;
            })}
        </div>
    );
}
